<template>
  <div v-if="loading" class="text-center mt-5 font-2xl text-muted">
    <i class="fal fa-spinner fa-spin" /> Test Process Data Loading...
  </div>
  <div v-else class="animated fadeIn">
    <basic-heading :title="`${test_process.name} Process`" class="mb-3">
      <template #right-content>
        <header-button-group :button_config="button_config" />
      </template>
    </basic-heading>

    <permission-alert-gate :permissions="['read test process']">
      <template #gated-content>
        <b-row class="mb-3">
          <b-col cols="6">
            <b-table-simple borderless striped>
              <b-tbody>
                <b-tr />

                <b-tr>
                  <b-th class="text-nowrap">
                    Name
                  </b-th>
                  <b-td class="w-100">
                    {{ test_process.name }}
                  </b-td>
                </b-tr>

                <b-tr>
                  <b-th class="text-nowrap">
                    Description
                  </b-th>
                  <b-td class="w-100">
                    {{ test_process.description }}
                  </b-td>
                </b-tr>
              </b-tbody>
            </b-table-simple>
          </b-col>

          <b-col cols="6">
            <h4>Export Map</h4>

            <div v-if="loadingExportMap" class="text-center">
              <i class="fal fa-spinner fa-spin" /> Loading Export Map...
            </div>
            <div v-else class="p-2 bg-light">
              <pre>{{ export_map.length > 0 ? export_map : '{}' }}</pre>
            </div>
          </b-col>
        </b-row>
      </template>
    </permission-alert-gate>

    <permission-alert-gate :permissions="['list test task']">
      <template #gated-content>
        <div>
          <h3>
            Tasks
            <b-button class="float-right" variant="success" :to="`/${route_root}/${sample_type_id}/${test_process_id}/add`">
              <i class="fal fa-plus" />
            </b-button>
          </h3>
        </div>

        <WorkflowTestTaskServerTable :sample_type_id="sample_type_id" :test_process_id="test_process_id" />
      </template>
    </permission-alert-gate>
  </div>
</template>

<script>
import BasicHeading from '@/components/shared/BasicHeading'
import HeaderButtonGroup from '@/components/shared/headerbuttons/HeaderButtonGroup'
import PermissionAlertGate from '@/components/permission/PermissionAlertGate'
import { getModel } from '@/shared/fetch-utils'
import WorkflowTestTaskServerTable from '@/components/lab/workflows/test/WorkflowTestTaskServerTable'
import { TestWorkflowRoutes } from '@/router/lab/TestWorkflowRoutes'

export default {
  name: 'WorkflowTestProcessDetail',
  components: {
    BasicHeading,
    HeaderButtonGroup,
    PermissionAlertGate,
    WorkflowTestTaskServerTable
  },
  data () {
    return {
      loading: true,
      sample_type_id: this.$route.params.sample_type_id || null,
      test_process_id: this.$route.params.test_process_id || null,
      test_process: null,

      export_map: [],
      loadingExportMap: false
    }
  },
  computed: {
    button_config () {
      return {
        buttons: [
          {
            icon: "fa-search",
            linkto: `/${this.route_root}/${this.sample_type_id}/${this.test_process_id}/audit-trail`,
            title: "Audit Trail",
            variant: "dark",
          },
          {
            icon: 'fa-pencil',
            title: 'Edit sample',
            variant: 'warning',
            linkto: `/${this.route_root}/${this.sample_type_id}/${this.test_process_id}/edit`
          }
        ]
      }
    },
    route_root () {
      return TestWorkflowRoutes.fetchRoot()
    }
  },
  async mounted () {
    this.loading = true

    this.test_process = await getModel({
      model_type: 'test_process',
      id: this.test_process_id,
      message: this.$bvToast
    })

    if (this.test_process && this.test_process.export_map && this.test_process.export_map.column_export) {
      await this.loadExportMap()
    }

    this.test_process ? (this.loading = false) : this.$router.back()
  },
  methods: {
    async loadExportMap () {
      this.loadingExportMap = true

      const promises = this.test_process.export_map.column_export.map(async (item) => {
        const modelType = item.type === 'analyte' ? 'analyte' : 'managed_list'
        const model = await getModel({
          model_type: modelType,
          id: item.type_id,
          message: this.$bvToast
        })

        return { ...item, type_attribute: model.name || model.description, type_id: undefined }
      })
      
      this.export_map = await Promise.all(promises)
      this.loadingExportMap = false
    }
  }
}
</script>
